// copied from https://github.com/sindresorhus/email-regex v5.0.0
const emailRegex = /^[^.\s@:](?:[^\s@:]*[^\s@:.])?@[^.\s@]+(?:\.[^.\s@]+)*$/;
// copied and modified from https://github.com/manishsaraan/email-validator v2.0.4
export const isValidEmail = (email) => {
    if (!email)
        return false;
    if (email.length > 254)
        return false;
    const emailParts = email.split('@');
    if (emailParts.length !== 2)
        return false;
    const [account, address] = emailParts;
    if (account.length > 64)
        return false;
    const domainParts = address.split('.');
    if (domainParts.some((part) => part.length > 63))
        return false;
    if (!emailRegex.test(email))
        return false;
    return true;
};
//# sourceMappingURL=email.js.map